import { Box } from '@chakra-ui/react'
import { SSRGate } from '@src/components/sco/utilities/SSRGate'
import React from 'react'
import { useInView } from 'react-intersection-observer'
import ReactPlayer from 'react-player'

interface VideoWalkthroughCardProps {
  url: string
}

const VideoWalkthroughCard = ({ url }: VideoWalkthroughCardProps) => {
  const { ref, inView } = useInView({
    threshold: 0.5, // Trigger when 50% of the component is visible
    triggerOnce: false, // Allow multiple triggers as user scrolls
  })

  return (
    <Box ref={ref} borderRadius={'2xl'} boxShadow={'lg'} flex={1.5} minHeight={'30%'} overflow={'hidden'}>
      <SSRGate disableSSR={true}>
        <ReactPlayer
          height={'auto'}
          light={false}
          loop={true}
          muted={true}
          pip={true}
          playing={inView}
          playsinline={true}
          url={url}
          width={'100%'}
        />
      </SSRGate>
    </Box>
  )
}

export default VideoWalkthroughCard
